import React, { useEffect, useState } from 'react';
import './equipamentsStyle.css';
import ReadMoreButton from '../../../../components/buttons/readMoreButton/readMoreButton';
import H2Title from './../../../../components/text/h2Title/h2Title'
import NormalTex from './../../../../components/text/normalText'

export default function Equipaments({title, text, imgSrc}) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowWidth(window.innerWidth)
    };

    useEffect( () => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    if (windowWidth < 769)
        return (
            <section className='equipaments__container'>
                <div className='equipaments__text-container'>
                    <H2Title title={title} color="white" width={"100%"}/>

                    <div className='equipaments__img-container'>
                        <img className='equipaments__img' src={imgSrc}/>
                    </div>

                    <NormalTex text={text}/>

                    <ReadMoreButton url={"/equipaments"}/>
                </div>
                
            </section>
        );

    return (
        <section className='equipaments__container'>
            <div className='equipaments__text-container'>
                <H2Title title={title}color={"white"} width={"100%"}/>
                <NormalTex text={text}/>
                <ReadMoreButton url={"/equipaments"}/>
            </div>
            <div className='equipaments__img-container'>
                <img className='equipaments__img' src={imgSrc}/>
            </div>
        </section>
    );
}
